import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, CdrUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { Job } from 'src/app/core/model/job';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-margin-dialog',
    templateUrl: './margin-dialog.component.html',
    styleUrls: ['./margin-dialog.component.scss'],
    imports: [DevExtremeModule]
})
export class MarginDialogComponent extends BaseDialogComponent<any> implements OnInit {
    jobId: number;
    job: any;
    relatedJob: any;
    invoiceAmount: number;
    includeRelated: boolean;
    isAdmin: boolean;

    constructor(
        private uow: CdrUnitOfWork,
        private appInfo: AppInformationService,
        private utility: UtilityService,
        private auth: AuthService
    ) {
        super();
    }

    async ngOnInit() {
        this.isAdmin = this.auth.hasRole('Admin');
        await this.getData();
    }

    async getData() {
        this.job = await this.uow.jobs.byId(
            this.jobId,
            'jobTimes, invoiceLines, relatedJob.jobTimes, relatedJob.invoiceLines, billAsDumpster, action'
        );

        if (!!this.job.relatedJobId && !!this.job.relatedJob.completed) {
            this.relatedJob = await this.uow.jobs.byId(
                this.job.relatedJobId,
                'jobTimes, invoiceLines, relatedJob.jobTimes, relatedJob.invoiceLines, billAsDumpster, action'
            );
        }
        this.calcAll();
    }

    calcAll() {
        this.calculateValues(this.job);
        if (!!this.relatedJob) {
            this.calculateValues(this.relatedJob);
            this.job.totalRevenue = this.job.invoiceAmount + this.relatedJob.invoiceAmount;
            this.job.totalProfits = this.job.profit + this.relatedJob.profit;
        }
    }

    calculateValues(job) {
        job.invoiceAmount = job.invoiceLines.filter(il => !il.deleted).reduce((sum, il) => sum + il.rate * il.quantity, 0);
        job.totalMinutes = job.jobTimes.filter(t => !t.deleted).reduce((sum, t) => sum + t.totalMinutes, 0);
        job.timeExpenses = (job.hourExpense * job.totalMinutes) / 60.0;
        job.tonExpenses = job.tonExpense * job.weight;

        job.profit = job.invoiceAmount - (job.tonExpenses + job.timeExpenses);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            }
        );
    }

    async recalculateMargin() {
        this.appInfo.pleaseWaitShow();
        await this.utility.updateJobMarginsByIds([this.jobId]);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    save = async () => {
        await this.uow.commit();
        this.recalculateMargin();
        this.hide();
    };

    cancel = async () => {
        this.uow.rollback();
        this.hide();
    };

    recalculateValues = async () => {
        this.calcAll();
    };

    hasChanges() {
        return this.uow.hasChanges();
    }
}
